import React from 'react';

import { Stack, Typography } from '@mui/material';
import ProfileForm from 'src/sections/profile/profile-form';
import { SlideIn } from '../SlideIn';
import { FormFooter } from './FormFooter';

export default function ProfileContent({ formData: _data, onNext, onBack }) {
  const [formData, setFormData] = React.useState(_data);
  const [isValid, setIsValid] = React.useState(false);

  const handleChange = (newData, valid) => {
    setFormData(newData);
    setIsValid(valid);
  };

  const handleNext = () => onNext({ profile: formData });

  return (
    <>
      <Stack spacing={4} alignItems="center" justifyContent="center" textAlign="center">
        <SlideIn direction="left">
          <Typography variant="h2" color="text.secondary">
            🪪
          </Typography>
          <Typography variant="h1">Profile Information</Typography>
          <SlideIn direction="left">
            <Typography variant="h3" color="text.secondary" fontWeight="light">
              Set up your profile to get started planning your financial future.
            </Typography>
          </SlideIn>
        </SlideIn>
        <ProfileForm initialData={formData?.profile} onChange={handleChange} />
      </Stack>
      <FormFooter {...{ isValid, onNext: handleNext, onBack }} />
    </>
  );
}
